<div class="page-content oder-detail-page" *ngIf="order_detail.store_detail">
  <div class="page-content-wrp">
    <div class="order-number-section">
      <div
        class="o-n-section-wrp d-flex justify-content-center align-items-center"
      >
        <h3>{{ helper.title.order_number | translate }}</h3>
        <span class="oder-no">#{{ order_detail.unique_id }}</span>
        <button class="primary-btn link-btn" (click)="openModal1(EditCart)">
          {{ helper.button.voir_detail_de_la_commande | translate }}
        </button>
      </div>
    </div>
    <div
      class="alert-order-status"
      *ngIf="order_detail.order_status_id == helper.ORDER_STATUS_ID.CANCELLED"
    >
      <div class="a-o-s-wrp d-flex justify-content-center align-items-center">
        <h3>{{ helper.title.order_status | translate }}</h3>
        <div class="alert-msg-box">
          <svg
            width="48"
            height="42"
            viewBox="0 0 48 42"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M47.3986 39.1406L25.4611 1.17188C25.1341 0.607617 24.5699 0.328125 24.0004 0.328125C23.4308 0.328125 22.8613 0.607617 22.5396 1.17188L0.602118 39.1406C-0.0465153 40.2691 0.765594 41.6719 2.06286 41.6719H45.9379C47.2351 41.6719 48.0472 40.2691 47.3986 39.1406ZM22.3129 15.9375C22.3129 15.7055 22.5027 15.5156 22.7347 15.5156H25.266C25.498 15.5156 25.6879 15.7055 25.6879 15.9375V25.6406C25.6879 25.8727 25.498 26.0625 25.266 26.0625H22.7347C22.5027 26.0625 22.3129 25.8727 22.3129 25.6406V15.9375ZM24.0004 34.5C23.338 34.4865 22.7073 34.2139 22.2436 33.7406C21.78 33.2674 21.5203 32.6313 21.5203 31.9688C21.5203 31.3062 21.78 30.6701 22.2436 30.1969C22.7073 29.7236 23.338 29.451 24.0004 29.4375C24.6627 29.451 25.2934 29.7236 25.7571 30.1969C26.2208 30.6701 26.4805 31.3062 26.4805 31.9688C26.4805 32.6313 26.2208 33.2674 25.7571 33.7406C25.2934 34.2139 24.6627 34.4865 24.0004 34.5Z"
            />
          </svg>
          <p>{{ helper.text.alert_text3 | translate }}</p>
          <span>{{
            order_detail.completed_at
              | date : "Ve. dd/MM à " + helper.website_data.time_format
          }}</span>
        </div>
      </div>
    </div>
    <div
      class="order-reason-section"
      *ngIf="order_detail.order_status_id == helper.ORDER_STATUS_ID.CANCELLED"
    >
      <div class="o-r-wrp d-flex justify-content-center align-items-center">
        <div
          class="reason-alert-box d-flex align-items-center justify-content-center"
          *ngIf="order_detail.cancel_reason"
        >
          <p>Raison : “{{ order_detail.cancel_reason }}”</p>
        </div>
        <div class="reason-content">
          <p>{{ helper.text.reason_content1 | translate }}</p>
          <p>{{ helper.text.reason_content2 | translate }}</p>
          <p>{{ helper.text.reason_content3 | translate }}</p>
        </div>
      </div>
    </div>
    <div
      class="order-time-section"
      *ngIf="order_detail.order_status_id !== helper.ORDER_STATUS_ID.CANCELLED"
    >
      <div
        class="o-t-section-wrp d-flex justify-content-center align-items-center"
      >
        <h3>
          <span *ngIf="!order_detail.is_user_pick_up_order"
            >{{ helper.label.delivery_time_title | translate }}
          </span>
          <span *ngIf="order_detail.is_user_pick_up_order"
            >{{ helper.label.delivery_time_title1 | translate }}
          </span>
          <span *ngIf="order_detail.is_schedule_order">
            {{
              order_detail.estimated_time_for_delivery_order
                | date : "EE. dd/MM à " + helper.website_data.time_format
            }}
          </span>
          <span *ngIf="!order_detail.is_schedule_order">
            {{
              order_detail.estimated_time_for_delivery_order
                | date : "à " + helper.website_data.time_format
            }}
          </span>
        </h3>
        <div
          class="order-add-time d-flex align-items-center"
          *ngIf="!order_detail.is_user_pick_up_order"
        >
          <div class="order-per">
            <label>{{ helper.label.par | translate }}</label>
            <div class="number-box d-flex align-items-center">
              <div class="n-box-icon">
                <span>
                  <svg
                    width="11"
                    height="11"
                    viewBox="0 0 11 11"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M0.484064 1.63263L1.81791 0.300034C1.912 0.205529 2.02384 0.130546 2.147 0.0793922C2.27015 0.0282381 2.4022 0.00192116 2.53556 0.00195315C2.80734 0.00195315 3.06284 0.108411 3.25446 0.300034L4.68976 1.73533C4.78427 1.82942 4.85925 1.94126 4.9104 2.06442C4.96156 2.18757 4.98787 2.31962 4.98784 2.45298C4.98784 2.72476 4.88138 2.98026 4.68976 3.17188L3.64022 4.22143C3.88589 4.76293 4.22746 5.25555 4.64843 5.67551C5.06835 6.09751 5.56092 6.44032 6.10251 6.68749L7.15206 5.63794C7.24615 5.54344 7.35799 5.46845 7.48114 5.4173C7.6043 5.36614 7.73635 5.33983 7.86971 5.33986C8.14149 5.33986 8.39699 5.44632 8.58861 5.63794L10.0252 7.07199C10.1198 7.16625 10.1948 7.27829 10.246 7.40167C10.2971 7.52505 10.3234 7.65732 10.3232 7.79089C10.3232 8.06267 10.2168 8.31816 10.0252 8.50979L8.69382 9.84113C8.38822 10.148 7.96615 10.3221 7.5328 10.3221C7.44137 10.3221 7.3537 10.3146 7.26728 10.2995C5.57899 10.0215 3.90448 9.12348 2.5531 7.77335C1.20296 6.42447 0.306217 4.75121 0.0244179 3.05791C-0.0607481 2.54065 0.110836 2.00836 0.484064 1.63263Z"
                    />
                  </svg>
                </span>
              </div>
              <div
                class="n-box-details"
                *ngIf="
                  !order_detail.provider_detail ||
                  order_detail.provider_detail.length == 0
                "
              >
                <p>Livreur en cours d’attribution...</p>
              </div>
              <div
                class="n-box-details"
                *ngIf="
                  order_detail.provider_detail &&
                  order_detail.provider_detail.length > 0
                "
              >
                <span
                  >{{ order_detail.provider_detail[0].first_name }}
                  {{ order_detail.provider_detail[0].last_name }}</span
                >
                <a
                  href="tel:{{
                    order_detail.provider_detail[0].country_phone_code
                  }}{{ order_detail.provider_detail[0].phone }}"
                  >{{ order_detail.provider_detail[0].country_phone_code
                  }}{{ order_detail.provider_detail[0].phone }}</a
                >
              </div>
            </div>
          </div>
          <div
            class="order-per order-a"
            [class.o-only-address]="order_detail.is_user_pick_up_order"
          >
            <label>{{ helper.label.a | translate }}</label>
            <div class="number-box d-flex align-items-center">
              <div class="n-box-icon">
                <span>
                  <svg
                    width="10"
                    height="13"
                    viewBox="0 0 10 13"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M4.78693 0C3.51782 0.00153024 2.30111 0.517484 1.40372 1.43468C0.506318 2.35188 0.0015023 3.59543 5.0928e-06 4.89254C-0.00151493 5.95254 0.337257 6.98378 0.964352 7.82806C0.964352 7.82806 1.0949 8.00375 1.11623 8.0291L4.78693 12.4537L8.45936 8.02688C8.47851 8.0033 8.6095 7.82806 8.6095 7.82806L8.60994 7.82673C9.23672 6.98282 9.57534 5.95205 9.57385 4.89254C9.57235 3.59543 9.06753 2.35188 8.17014 1.43468C7.27274 0.517484 6.05604 0.00153024 4.78693 0ZM4.78693 6.67164C4.44265 6.67164 4.1061 6.5673 3.81985 6.37181C3.53359 6.17632 3.31048 5.89846 3.17873 5.57337C3.04698 5.24828 3.01251 4.89057 3.07967 4.54545C3.14684 4.20034 3.31263 3.88333 3.55607 3.63452C3.79951 3.38571 4.10967 3.21627 4.44733 3.14762C4.785 3.07897 5.13499 3.1142 5.45306 3.24886C5.77113 3.38352 6.04299 3.61155 6.23426 3.90412C6.42553 4.19669 6.52763 4.54067 6.52763 4.89254C6.52705 5.36421 6.34347 5.81639 6.01715 6.14991C5.69083 6.48343 5.24841 6.67106 4.78693 6.67164Z"
                    />
                  </svg>
                </span>
              </div>
              <div class="n-box-details">
                <span>{{ order_detail.destination_address }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="status-order-command"
      *ngIf="order_detail.order_status_id !== helper.ORDER_STATUS_ID.CANCELLED"
    >
      <div class="s-o-c-wrp d-flex justify-content-center align-items-center">
        <h3>
          {{ helper.title.order_status | translate }}
        </h3>
        <div
          class="order-status-box d-flex align-items-center justify-content-center"
          *ngIf="
            order_detail.order_status ==
            helper.ORDER_STATE.WAITING_FOR_ACCEPT_STORE
          "
        >
          <svg
            width="48"
            height="40"
            viewBox="0 0 48 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M47.2076 21.2915L42.5295 16.0458C42.2197 15.7311 41.8023 15.5547 41.3675 15.5547C40.9327 15.5547 40.5153 15.7311 40.2055 16.0458L35.5214 21.2915C35.3685 21.4475 35.2472 21.6332 35.1644 21.8379C35.0816 22.0425 35.0389 22.2621 35.0389 22.4839C35.0389 22.7057 35.0816 22.9253 35.1644 23.13C35.2472 23.3347 35.3685 23.5204 35.5214 23.6764H39.3968C38.6719 26.4857 37.2409 29.0478 35.2483 31.1037C33.2557 33.1596 30.7723 34.6365 28.049 35.385C24.8665 36.2437 21.5054 36.0767 18.4177 34.9064C15.3299 33.7361 12.6636 31.6186 10.7772 28.8387L7.50977 31.1588C9.86349 34.6275 13.1906 37.2694 17.0436 38.7292C20.8966 40.189 25.0906 40.3965 29.0613 39.3239C32.6325 38.3472 35.8708 36.3673 38.4157 33.6047C40.9607 30.8421 42.7124 27.4051 43.4759 23.6764H47.2046C47.3573 23.5204 47.4786 23.3348 47.5614 23.1302C47.6443 22.9257 47.6871 22.7063 47.6873 22.4846C47.6876 22.2629 47.6454 22.0433 47.563 21.8386C47.4807 21.6338 47.3599 21.4479 47.2076 21.2915Z"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M13.2978 18.5507C13.4506 18.3947 13.572 18.209 13.6548 18.0043C13.7376 17.7996 13.7803 17.58 13.7803 17.3583C13.7803 17.1365 13.7376 16.9169 13.6548 16.7122C13.572 16.5075 13.4506 16.3218 13.2978 16.1658H8.93417C9.67654 13.3919 11.1095 10.8667 13.0908 8.84091C15.072 6.8151 17.5326 5.35922 20.2281 4.61787C23.4107 3.75816 26.7723 3.92537 29.86 5.09695C32.9476 6.26853 35.613 8.38819 37.4969 11.1703L40.7673 8.84715C38.4129 5.37654 35.0845 2.73299 31.2299 1.27213C27.3753 -0.188729 23.1795 -0.396809 19.2068 0.675884C15.6632 1.64813 12.4474 3.60771 9.91169 6.33992C7.376 9.07214 5.61828 12.4716 4.83111 16.1658H0.482463C0.329612 16.3218 0.208269 16.5075 0.125455 16.7122C0.0426406 16.9169 0 17.1365 0 17.3583C0 17.58 0.0426406 17.7996 0.125455 18.0043C0.208269 18.209 0.329612 18.3947 0.482463 18.5507L5.38817 23.608C5.698 23.9227 6.11538 24.099 6.5502 24.099C6.98502 24.099 7.40241 23.9227 7.71224 23.608L13.2978 18.5507Z"
            />
            <path
              d="M21.0756 20.7868L23.1437 22.92L27.9692 17.9424M30.0372 22.92C29.3479 23.6311 30.8989 25.5866 30.0372 26.4754C29.1755 27.3643 27.2798 25.7643 26.5904 26.4754C25.9011 27.1865 25.5564 28.6087 24.5224 28.6087C23.4883 28.6087 23.1437 27.1865 22.4543 26.4754C21.7649 25.7643 19.8692 27.3643 19.0075 26.4754C18.1458 25.5866 19.6969 23.6311 19.0075 22.92C18.3182 22.2089 16.9395 21.8534 16.9395 20.7868C16.9395 19.7201 18.3182 19.3646 19.0075 18.6535C19.6969 17.9424 18.1458 15.9869 19.0075 15.0981C19.8692 14.2092 21.7649 15.8092 22.4543 15.0981C23.1437 14.387 23.4883 12.9648 24.5224 12.9648C25.5564 12.9648 25.9011 14.387 26.5904 15.0981C27.2798 15.8092 29.1755 14.2092 30.0372 15.0981C30.8989 15.9869 29.3479 17.9424 30.0372 18.6535C30.7266 19.3646 32.1053 19.7201 32.1053 20.7868C32.1053 21.8534 30.7266 22.2089 30.0372 22.92Z"
              stroke-width="1.45764"
            />
          </svg>
          <span>
            {{ helper.status.order_status1 | translate }}
          </span>
          <!-- <label class="time">12:34</label> -->
        </div>
        <div
          class="order-status-box d-flex align-items-center justify-content-center"
          *ngIf="order_detail.order_status == helper.ORDER_STATE.STORE_ACCEPTED"
        >
          <svg
            width="43"
            height="43"
            viewBox="0 0 43 43"
            style="fill: #fff"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              style="stroke: var(--theme-primary-color)"
              d="M12.6775 21.4443L17.9762 26.7776L30.3399 14.3331M35.6386 26.7776C33.8724 28.5554 37.8464 33.4443 35.6386 35.6665C33.4308 37.8887 28.5736 33.8887 26.8074 35.6665C25.0412 37.4443 24.158 40.9999 21.5087 40.9999C18.8593 40.9999 17.9762 37.4443 16.21 35.6665C14.4437 33.8887 9.58659 37.8887 7.37879 35.6665C5.17099 33.4443 9.14503 28.5554 7.37879 26.7776C5.61255 24.9998 2.08008 24.1109 2.08008 21.4443C2.08008 18.7776 5.61255 17.8887 7.37879 16.1109C9.14503 14.3331 5.17099 9.44424 7.37879 7.22202C9.58659 4.99979 14.4437 8.9998 16.21 7.22202C17.9762 5.44424 18.8593 1.88867 21.5087 1.88867C24.158 1.88867 25.0412 5.44424 26.8074 7.22202C28.5736 8.9998 33.4308 4.99979 35.6386 7.22202C37.8464 9.44424 33.8724 14.3331 35.6386 16.1109C37.4048 17.8887 40.9373 18.7776 40.9373 21.4443C40.9373 24.1109 37.4048 24.9998 35.6386 26.7776Z"
              stroke="#F8004A"
              stroke-width="3.53247"
            />
          </svg>
          <span>
            {{ helper.status.order_status2 | translate }}
          </span>
        </div>
        <div
          class="order-status-box d-flex align-items-center justify-content-center"
          *ngIf="
            order_detail.order_status == helper.ORDER_STATE.OREDER_READY &&
            order_detail.is_user_pick_up_order
          "
        >
          <svg
            width="35"
            height="31"
            viewBox="0 0 35 31"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M10.3906 5.46875V2.1875C10.3906 1.75238 10.5635 1.33508 10.8712 1.0274C11.1788 0.719726 11.5961 0.546875 12.0313 0.546875C12.4664 0.546875 12.8837 0.719726 13.1914 1.0274C13.499 1.33508 13.6719 1.75238 13.6719 2.1875V5.46875C13.6719 5.90387 13.499 6.32117 13.1914 6.62885C12.8837 6.93652 12.4664 7.10938 12.0313 7.10938C11.5961 7.10938 11.1788 6.93652 10.8712 6.62885C10.5635 6.32117 10.3906 5.90387 10.3906 5.46875ZM17.5 7.10938C17.9351 7.10938 18.3524 6.93652 18.6601 6.62885C18.9678 6.32117 19.1406 5.90387 19.1406 5.46875V2.1875C19.1406 1.75238 18.9678 1.33508 18.6601 1.0274C18.3524 0.719726 17.9351 0.546875 17.5 0.546875C17.0649 0.546875 16.6476 0.719726 16.3399 1.0274C16.0322 1.33508 15.8594 1.75238 15.8594 2.1875V5.46875C15.8594 5.90387 16.0322 6.32117 16.3399 6.62885C16.6476 6.93652 17.0649 7.10938 17.5 7.10938ZM22.9688 7.10938C23.4039 7.10938 23.8212 6.93652 24.1289 6.62885C24.4365 6.32117 24.6094 5.90387 24.6094 5.46875V2.1875C24.6094 1.75238 24.4365 1.33508 24.1289 1.0274C23.8212 0.719726 23.4039 0.546875 22.9688 0.546875C22.5336 0.546875 22.1163 0.719726 21.8087 1.0274C21.501 1.33508 21.3281 1.75238 21.3281 2.1875V5.46875C21.3281 5.90387 21.501 6.32117 21.8087 6.62885C22.1163 6.93652 22.5336 7.10938 22.9688 7.10938ZM34.3438 14.4375L30.625 17.2266V25.1562C30.625 26.4616 30.1065 27.7135 29.1834 28.6365C28.2604 29.5596 27.0085 30.0781 25.7031 30.0781H9.29688C7.99152 30.0781 6.73962 29.5596 5.81659 28.6365C4.89356 27.7135 4.37501 26.4616 4.37501 25.1562V17.2266L0.656257 14.4375C0.30816 14.1764 0.0780312 13.7878 0.0164958 13.357C-0.0450396 12.9263 0.0670592 12.4887 0.328132 12.1406C0.589204 11.7925 0.977865 11.5624 1.40861 11.5009C1.83936 11.4393 2.27691 11.5514 2.62501 11.8125L4.37501 13.125V12.0312C4.3786 11.3072 4.66784 10.6137 5.17986 10.1017C5.69187 9.58971 6.38529 9.30047 7.10938 9.29688H27.8906C28.6147 9.30047 29.3081 9.58971 29.8202 10.1017C30.3322 10.6137 30.6214 11.3072 30.625 12.0312V13.125L32.375 11.8125C32.7231 11.5514 33.1607 11.4393 33.5914 11.5009C34.0221 11.5624 34.4108 11.7925 34.6719 12.1406C34.933 12.4887 35.0451 12.9263 34.9835 13.357C34.922 13.7878 34.6919 14.1764 34.3438 14.4375ZM27.3438 12.5781H7.65626V25.1562C7.65626 25.5914 7.82911 26.0087 8.13678 26.3163C8.44446 26.624 8.86176 26.7969 9.29688 26.7969H25.7031C26.1383 26.7969 26.5556 26.624 26.8632 26.3163C27.1709 26.0087 27.3438 25.5914 27.3438 25.1562V12.5781Z"
              fill="#F8004A"
            />
          </svg>

          <span>
            {{ helper.status.order_status3 | translate }}
            <p>{{ order_detail.store_detail.name }}</p>
          </span>
        </div>
        <div
          class="order-status-box d-flex align-items-center justify-content-center"
          *ngIf="
            order_detail.order_status == helper.ORDER_STATE.OREDER_READY &&
            !order_detail.is_user_pick_up_order
          "
        >
          <svg
            width="31"
            height="31"
            viewBox="0 0 31 31"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clip-path="url(#clip0_3176_7182)">
              <path
                d="M6.51 9.91992C2.93229 9.91992 0 12.8432 0 16.4113C0 17.7939 0.44144 19.0789 1.18885 20.135L5.71578 27.9607C6.34973 28.789 6.77133 28.6318 7.29864 27.9173L12.2915 19.4202C12.3923 19.2373 12.4713 19.0432 12.5404 18.8448C12.8573 18.0726 13.0202 17.246 13.02 16.4113C13.02 12.8432 10.0886 9.91992 6.51 9.91992ZM6.51 12.9616C8.43696 12.9616 9.9696 14.4903 9.9696 16.4116C9.9696 18.333 8.43696 19.861 6.51 19.861C4.58335 19.861 3.0504 18.3327 3.0504 16.4116C3.0504 14.4903 4.58335 12.9616 6.51 12.9616Z"
                fill="#F8004A"
              />
              <path
                d="M27.2018 0C25.1149 0 23.4043 1.70531 23.4043 3.78696C23.4043 4.59327 23.6616 5.34285 24.0978 5.95882L26.7387 10.5239C27.1085 11.0069 27.3543 10.9151 27.6618 10.4985L30.5743 5.54156C30.6332 5.43523 30.6794 5.32208 30.7194 5.20614C30.9043 4.75584 30.9993 4.27374 30.9993 3.78696C30.9993 1.705 29.2893 0 27.2018 0ZM27.2018 1.77444C28.3259 1.77444 29.2199 2.666 29.2199 3.78696C29.2199 4.90761 28.3259 5.79886 27.2018 5.79886C26.078 5.79886 25.1837 4.90761 25.1837 3.78696C25.1837 2.666 26.078 1.77444 27.2018 1.77444Z"
                fill="#F8004A"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M27.3451 11.5977C26.6486 11.6132 25.9501 11.6426 25.2505 11.6944L25.3583 13.4093C26.0304 13.3606 26.7037 13.3293 27.3774 13.3154L27.3451 11.5977ZM23.6329 11.8519C22.5572 11.9855 21.4722 12.1758 20.3996 12.4818L20.8035 14.1437C21.7782 13.8659 22.7881 13.6864 23.8139 13.559L23.6329 11.8519ZM18.7935 13.0571C18.4721 13.199 18.1609 13.363 17.8622 13.5479L17.861 13.5494L17.8591 13.55C17.4329 13.8185 16.9837 14.1592 16.617 14.6543C16.3513 15.0129 16.134 15.4665 16.0831 16.0028L17.6626 16.1779C17.6744 16.052 17.7389 15.8859 17.8548 15.7296H17.8554V15.729C18.0423 15.4761 18.3226 15.2464 18.6558 15.0362L18.6571 15.0356C18.8946 14.889 19.142 14.7589 19.3974 14.6462L18.7935 13.0571ZM17.9803 16.943L16.9564 18.2558C17.1991 18.4778 17.4537 18.6483 17.6995 18.7909L17.7026 18.7924L17.7057 18.7943C18.5216 19.2584 19.3629 19.5203 20.1429 19.7689L20.5912 18.1204C19.8115 17.8717 19.0765 17.6318 18.4466 17.2741C18.2662 17.1693 18.1081 17.0599 17.9803 16.943ZM22.1142 18.5841L21.6765 20.2355L21.8836 20.3L22.1378 20.3812C22.9791 20.6549 23.7851 20.9473 24.5055 21.3518L25.2365 19.8266C24.3654 19.3371 23.4611 19.0172 22.5897 18.7339L22.5873 18.7332L22.3262 18.6498L22.1142 18.5841ZM26.723 20.9711L25.5998 22.1863C25.8652 22.4737 26.0639 22.8193 26.1606 23.1765L26.1612 23.1783L26.1619 23.1811C26.2772 23.5981 26.2775 24.0885 26.1873 24.5839L27.7447 24.9162C27.8718 24.2168 27.8923 23.449 27.6833 22.691C27.5014 22.0208 27.1542 21.4386 26.723 20.9711ZM25.6435 25.6193C25.4719 25.8005 25.2822 25.9638 25.0775 26.1066H25.0769C24.5189 26.499 23.8716 26.7948 23.184 27.049L23.6967 28.6746C24.4488 28.3966 25.221 28.0556 25.9427 27.5478L25.9445 27.5462L25.9455 27.5456C26.2419 27.3381 26.516 27.1005 26.7636 26.8366L25.6435 25.6193ZM21.7251 27.5069C20.7291 27.7747 19.7111 27.9787 18.6806 28.1517L18.9237 29.8501C19.9842 29.6719 21.049 29.4589 22.1074 29.1743L21.7251 27.5069ZM17.1303 28.386C16.0931 28.5277 15.0502 28.6433 14.0043 28.7419L14.1413 30.4537C15.2034 30.3539 16.2673 30.2364 17.3297 30.091L17.1303 28.386ZM12.4323 28.8767C11.3842 28.9598 10.3336 29.0274 9.28205 29.0844L9.36141 30.8006C10.4232 30.7433 11.4858 30.6747 12.5482 30.5904L12.4323 28.8767ZM7.70198 29.1619C7.07175 29.1914 6.43997 29.2156 5.80664 29.2379L5.85872 30.9556C6.49601 30.9337 7.13317 30.9083 7.77018 30.8793L7.70198 29.1619Z"
                fill="#F8004A"
              />
            </g>
            <defs>
              <clipPath id="clip0_3176_7182">
                <rect width="31" height="31" fill="white" />
              </clipPath>
            </defs>
          </svg>

          <span
            *ngIf="
              order_detail.provider_detail &&
              order_detail.provider_detail.length > 0
            "
          >
            {{ helper.status.order_status4 | translate }}
            <!-- <p>“1 Rue des Charmille, 4000 Genève”</p> -->
            <!-- <div class="n-box-details"> -->
            <p
              *ngIf="
                order_detail.delivery_status >=
                helper.ORDER_STATE.DELIVERY_MAN_PICKED_ORDER
              "
            >
              {{ order_detail.destination_address }}
            </p>
            <p
              *ngIf="
                order_detail.delivery_status <
                helper.ORDER_STATE.DELIVERY_MAN_PICKED_ORDER
              "
            >
              {{ order_detail.store_detail.name }}
            </p>
            <!-- </div>   -->
          </span>
          <span
            *ngIf="
              !order_detail.provider_detail ||
              order_detail.provider_detail.length == 0
            "
          >
            Votre commande est prête, Livreur en cours d’attribution...
          </span>
        </div>
        <div
          class="order-status-box d-flex align-items-center justify-content-center"
          *ngIf="
            order_detail.order_status == helper.ORDER_STATE.ORDER_COMPLETED &&
            order_detail.is_user_pick_up_order
          "
        >
          <svg
            width="43"
            height="43"
            viewBox="0 0 43 43"
            style="fill: #fff"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              style="stroke: var(--theme-primary-color)"
              d="M12.6775 21.4443L17.9762 26.7776L30.3399 14.3331M35.6386 26.7776C33.8724 28.5554 37.8464 33.4443 35.6386 35.6665C33.4308 37.8887 28.5736 33.8887 26.8074 35.6665C25.0412 37.4443 24.158 40.9999 21.5087 40.9999C18.8593 40.9999 17.9762 37.4443 16.21 35.6665C14.4437 33.8887 9.58659 37.8887 7.37879 35.6665C5.17099 33.4443 9.14503 28.5554 7.37879 26.7776C5.61255 24.9998 2.08008 24.1109 2.08008 21.4443C2.08008 18.7776 5.61255 17.8887 7.37879 16.1109C9.14503 14.3331 5.17099 9.44424 7.37879 7.22202C9.58659 4.99979 14.4437 8.9998 16.21 7.22202C17.9762 5.44424 18.8593 1.88867 21.5087 1.88867C24.158 1.88867 25.0412 5.44424 26.8074 7.22202C28.5736 8.9998 33.4308 4.99979 35.6386 7.22202C37.8464 9.44424 33.8724 14.3331 35.6386 16.1109C37.4048 17.8887 40.9373 18.7776 40.9373 21.4443C40.9373 24.1109 37.4048 24.9998 35.6386 26.7776Z"
              stroke="#F8004A"
              stroke-width="3.53247"
            />
          </svg>
          <span>
            {{ helper.status.order_status5 | translate }}
          </span>
        </div>
        <div
          class="order-status-box d-flex align-items-center justify-content-center"
          *ngIf="
            order_detail.order_status == helper.ORDER_STATE.ORDER_COMPLETED &&
            !order_detail.is_user_pick_up_order
          "
        >
          <svg
            width="43"
            height="43"
            viewBox="0 0 43 43"
            style="fill: #fff"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              style="stroke: var(--theme-primary-color)"
              d="M12.6775 21.4443L17.9762 26.7776L30.3399 14.3331M35.6386 26.7776C33.8724 28.5554 37.8464 33.4443 35.6386 35.6665C33.4308 37.8887 28.5736 33.8887 26.8074 35.6665C25.0412 37.4443 24.158 40.9999 21.5087 40.9999C18.8593 40.9999 17.9762 37.4443 16.21 35.6665C14.4437 33.8887 9.58659 37.8887 7.37879 35.6665C5.17099 33.4443 9.14503 28.5554 7.37879 26.7776C5.61255 24.9998 2.08008 24.1109 2.08008 21.4443C2.08008 18.7776 5.61255 17.8887 7.37879 16.1109C9.14503 14.3331 5.17099 9.44424 7.37879 7.22202C9.58659 4.99979 14.4437 8.9998 16.21 7.22202C17.9762 5.44424 18.8593 1.88867 21.5087 1.88867C24.158 1.88867 25.0412 5.44424 26.8074 7.22202C28.5736 8.9998 33.4308 4.99979 35.6386 7.22202C37.8464 9.44424 33.8724 14.3331 35.6386 16.1109C37.4048 17.8887 40.9373 18.7776 40.9373 21.4443C40.9373 24.1109 37.4048 24.9998 35.6386 26.7776Z"
              stroke="#F8004A"
              stroke-width="3.53247"
            />
          </svg>
          <span>
            {{ helper.status.order_status6 | translate }}
          </span>
        </div>
        <button
          class="primary-btn"
          *ngIf="
            order_detail.order_status ==
            helper.ORDER_STATE.WAITING_FOR_ACCEPT_STORE
          "
          (click)="openModal(CancelOrder)"
        >
          {{ helper.button.annuler_votre_commande | translate }}
        </button>
      </div>
    </div>
    <div class="remain-disposal">
      <div class="r-d-wrp d-flex justify-content-center align-items-center">
        <h3>{{ helper.title.restons_disposition | translate }}</h3>
        <div class="da-gabriele">
          <h3>{{ order_detail.store_detail.name }}</h3>
          <p>{{ order_detail.store_detail.address }}</p>
          <div
            class="da-phone d-flex align-items-center justify-content-center"
          >
            <span
              ><svg
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M13.0073 9.64956L10.2323 8.46028C10.1138 8.40976 9.98203 8.39911 9.85691 8.42994C9.73179 8.46078 9.62007 8.53142 9.53857 8.63124L8.30964 10.1327C6.38095 9.22335 4.8288 7.6712 3.91944 5.74251L5.42092 4.51358C5.52093 4.43224 5.59173 4.32052 5.62257 4.19534C5.65342 4.07016 5.64264 3.93834 5.59188 3.81983L4.40259 1.04483C4.34687 0.917086 4.24832 0.812785 4.12394 0.749915C3.99955 0.687045 3.85713 0.669546 3.72123 0.700436L1.14444 1.29508C1.01341 1.32534 0.896512 1.39911 0.812813 1.50436C0.729115 1.60962 0.683564 1.74013 0.683594 1.87461C0.683594 8.22985 5.83469 13.371 12.18 13.371C12.3145 13.3711 12.4451 13.3256 12.5504 13.2419C12.6557 13.1582 12.7295 13.0413 12.7598 12.9102L13.3544 10.3334C13.3851 10.1968 13.3673 10.0538 13.3039 9.92903C13.2406 9.80422 13.1357 9.70539 13.0073 9.64956Z"
                />
              </svg>
            </span>
            {{ order_detail.store_detail.country_phone_code
            }}{{ order_detail.store_detail.phone }}
          </div>
        </div>
      </div>
    </div>
    <div class="powered-by-hop">
      <span
        >{{ helper.text.powered_by | translate }} Pronto-Resto
        <svg
          width="22"
          height="22"
          viewBox="0 0 22 22"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_3176_4387)">
            <path
              d="M15.7797 9.45581C15.7996 9.54182 15.7925 9.63191 15.7593 9.7137C15.726 9.7955 15.6682 9.86499 15.5939 9.91264C15.5195 9.96028 15.4323 9.98375 15.3441 9.97981C15.2559 9.97586 15.171 9.94471 15.1012 9.89062C15.0314 9.83653 14.9801 9.76216 14.9543 9.67773C14.9284 9.59329 14.9294 9.50292 14.9569 9.41904C14.9845 9.33516 15.0374 9.26188 15.1083 9.20925C15.1792 9.15663 15.2647 9.12725 15.353 9.12514C15.4513 9.12262 15.5475 9.15416 15.6252 9.21442C15.703 9.27468 15.7575 9.35995 15.7797 9.45581Z"
              fill="#9B9B9B"
            />
            <path
              d="M10.9769 3.65484e-05C8.89793 0.00517841 6.86298 0.599526 5.10804 1.71416C3.3531 2.82879 1.95006 4.41805 1.06161 6.29765C0.173157 8.17725 -0.164303 10.2702 0.0883557 12.3338C0.341015 14.3974 1.17344 16.3471 2.48911 17.9568C2.89951 17.3634 3.36064 16.7428 3.85256 16.1295C3.82282 16.1376 3.79255 16.1437 3.76197 16.1476C3.62023 16.1667 3.47602 16.1434 3.3475 16.0807C3.21897 16.018 3.11187 15.9186 3.03968 15.7952C2.96749 15.6717 2.93344 15.5297 2.94182 15.3869C2.95019 15.2441 3.00062 15.107 3.08675 14.9929C3.17288 14.8787 3.29086 14.7925 3.42584 14.7453C3.56082 14.698 3.70677 14.6918 3.8453 14.7273C3.98383 14.7628 4.10877 14.8385 4.20436 14.9449C4.29996 15.0512 4.36196 15.1835 4.38254 15.325C4.38931 15.3761 4.39113 15.4276 4.38798 15.479C5.69526 13.9389 7.24262 12.6081 8.53993 11.8317C8.54808 11.8317 9.71766 11.2682 9.85446 11.2419C9.92422 11.2274 8.93402 11.2655 8.55805 11.2745C8.00877 11.2867 7.45923 11.2686 6.91194 11.2202C5.69798 11.0689 2.53622 10.0615 3.65597 9.55052C4.8337 9.00695 7.9257 8.968 8.72927 8.93901C9.12336 8.92542 10.2277 9.06584 10.167 9.01783C9.79104 8.71615 7.12484 8.82486 5.3818 7.49855C4.92158 7.14886 5.03029 6.56815 5.7324 6.55818C8.2455 6.52013 10.0809 6.49114 12.3322 7.45507C12.9455 7.764 13.0452 7.82651 13.4058 7.78212C15.2865 7.54929 16.8022 8.27404 17.6782 9.71269C18.0288 10.288 17.8512 10.4791 17.4617 11.1069C16.9335 11.9567 14.9604 12.1941 14.5201 12.1252C14.5137 12.2142 14.5255 12.3036 14.5545 12.3879C15.2793 12.3227 16.7976 12.3816 17.4798 12.5474C17.7516 12.6144 18.1393 12.7612 18.114 13.2803C18.0931 13.765 17.5514 14.0114 17.3512 14.0051C13.577 13.8882 8.66857 16.2699 4.86451 18.7722C4.60903 18.9397 4.27383 19.1581 3.90239 19.3973C5.25479 20.5411 6.86341 21.3413 8.59147 21.7301C10.3195 22.1188 12.1159 22.0844 13.8278 21.6299C15.5397 21.1753 17.1166 20.3141 18.4242 19.1194C19.7319 17.9247 20.7317 16.4319 21.3386 14.7678C21.9455 13.1038 22.1415 11.3179 21.9101 9.5618C21.6786 7.80576 21.0265 6.13158 20.0092 4.68164C18.9918 3.2317 17.6394 2.0489 16.0668 1.23381C14.4943 0.418728 12.7482 -0.00452911 10.9769 3.65484e-05Z"
              fill="#9B9B9B"
            />
          </g>
          <defs>
            <clipPath id="clip0_3176_4387">
              <rect width="22.0009" height="22" fill="white" />
            </clipPath>
          </defs>
        </svg>
      </span>
    </div>
  </div>
</div>

<ng-template #CancelOrder let-modal>
  <!-- <button type="button" class="close pull-right" aria-label="Close" (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true"><svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0.641964 4.44674C0.27079 4.07556 0.0852035 3.64252 0.0852036 3.14762C0.0852039 2.65272 0.270791 2.21969 0.641965 1.84851C1.01314 1.47734 1.43844 1.29948 1.91788 1.31495C2.39731 1.33042 2.82261 1.52374 3.19379 1.89491L12.6355 11.3367C13.0067 11.7078 13.1923 12.1409 13.1923 12.6358C13.2078 13.1152 13.0299 13.5405 12.6587 13.9117C12.2876 14.2829 11.8545 14.4684 11.3596 14.4684C10.8802 14.453 10.4549 14.2597 10.0837 13.8885L0.641964 4.44674ZM0.804354 13.6565C0.371317 13.2235 0.147065 12.7208 0.1316 12.1486C0.1316 11.5918 0.348119 11.0969 0.781156 10.6639L9.82853 1.61653C10.2616 1.18349 10.7642 0.974707 11.3364 0.990173C11.9087 1.00564 12.4113 1.22989 12.8443 1.66293C13.2928 2.11143 13.5093 2.60633 13.4939 3.14763C13.4939 3.70439 13.2774 4.19929 12.8443 4.63232L3.79695 13.6797C3.36391 14.1127 2.86901 14.3293 2.31225 14.3293C1.75549 14.3293 1.25286 14.105 0.804354 13.6565Z"/>
            </svg></span>
    </button> -->
  <button
    type="button"
    class="close with-name pull-right d-flex align-items-center"
    aria-label="Close"
    (click)="modal.dismiss('Cross click')"
  >
    <span aria-hidden="true">
      <label>{{ helper.button.fermer | translate }}</label>
      <svg
        width="30"
        height="30"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15 3C12.6266 3 10.3066 3.70379 8.33316 5.02236C6.35977 6.34094 4.8217 8.21508 3.91345 10.4078C3.0052 12.6005 2.76756 15.0133 3.23058 17.3411C3.6936 19.6689 4.83649 21.807 6.51472 23.4853C8.19295 25.1635 10.3311 26.3064 12.6589 26.7694C14.9867 27.2324 17.3995 26.9948 19.5922 26.0865C21.7849 25.1783 23.6591 23.6402 24.9776 21.6668C26.2962 19.6934 27 17.3734 27 15C27 13.4241 26.6896 11.8637 26.0866 10.4078C25.4835 8.95189 24.5996 7.62902 23.4853 6.51472C22.371 5.40041 21.0481 4.5165 19.5922 3.91345C18.1363 3.31039 16.5759 3 15 3ZM18.252 16.548C18.3645 16.6596 18.4538 16.7923 18.5147 16.9385C18.5756 17.0847 18.607 17.2416 18.607 17.4C18.607 17.5584 18.5756 17.7153 18.5147 17.8615C18.4538 18.0077 18.3645 18.1404 18.252 18.252C18.1404 18.3645 18.0077 18.4537 17.8615 18.5147C17.7153 18.5756 17.5584 18.607 17.4 18.607C17.2416 18.607 17.0847 18.5756 16.9385 18.5147C16.7923 18.4537 16.6596 18.3645 16.548 18.252L15 16.692L13.452 18.252C13.3404 18.3645 13.2077 18.4537 13.0615 18.5147C12.9153 18.5756 12.7584 18.607 12.6 18.607C12.4416 18.607 12.2847 18.5756 12.1385 18.5147C11.9923 18.4537 11.8596 18.3645 11.748 18.252C11.6355 18.1404 11.5463 18.0077 11.4853 17.8615C11.4244 17.7153 11.393 17.5584 11.393 17.4C11.393 17.2416 11.4244 17.0847 11.4853 16.9385C11.5463 16.7923 11.6355 16.6596 11.748 16.548L13.308 15L11.748 13.452C11.522 13.226 11.3951 12.9196 11.3951 12.6C11.3951 12.2804 11.522 11.974 11.748 11.748C11.974 11.522 12.2804 11.3951 12.6 11.3951C12.9196 11.3951 13.226 11.522 13.452 11.748L15 13.308L16.548 11.748C16.774 11.522 17.0804 11.3951 17.4 11.3951C17.7196 11.3951 18.026 11.522 18.252 11.748C18.478 11.974 18.6049 12.2804 18.6049 12.6C18.6049 12.9196 18.478 13.226 18.252 13.452L16.692 15L18.252 16.548Z"
        />
      </svg>
    </span>
  </button>
  <div class="modal-body">
    <div class="modal-body-wrp">
      <h3>{{ helper.title.cancel_order_title | translate }}</h3>
      <div class="cancel-order-form">
        <ul>
          <li [class.active]="cancel_reason == helper.text.cancel_list1">
            <form action="">
              <label class="check_lb">
                <p>{{ helper.text.cancel_list1 | translate }}</p>
                <input
                  (click)="cancel_reason = helper.text.cancel_list1"
                  type="radio"
                  name="cancel_reason"
                  [checked]="cancel_reason == helper.text.cancel_list1"
                />
                <span class="checkmark sign_in_checkmak"></span>
              </label>
            </form>
          </li>
          <li [class.active]="cancel_reason == helper.text.cancel_list2">
            <form action="">
              <label class="check_lb">
                <p>{{ helper.text.cancel_list2 | translate }}</p>
                <input
                  (click)="cancel_reason = helper.text.cancel_list2"
                  type="radio"
                  name="cancel_reason"
                  [checked]="cancel_reason == helper.text.cancel_list2"
                />
                <span class="checkmark sign_in_checkmak"></span>
              </label>
            </form>
          </li>
          <li
            [class.active]="
              cancel_reason !== helper.text.cancel_list1 &&
              cancel_reason !== helper.text.cancel_list2
            "
          >
            <form action="">
              <label class="check_lb">
                <p>{{ helper.text.cancel_list3 | translate }}</p>
                <input
                  (click)="cancel_reason = ''"
                  name="cancel_reason"
                  [checked]="
                    cancel_reason !== helper.text.cancel_list1 &&
                    cancel_reason !== helper.text.cancel_list2
                  "
                  type="radio"
                />
                <span class="checkmark sign_in_checkmak"></span>
              </label>
              <textarea
                *ngIf="
                  cancel_reason !== helper.text.cancel_list1 &&
                  cancel_reason !== helper.text.cancel_list2
                "
                name="cancel_reason"
                [(ngModel)]="cancel_reason"
                cols="10"
                rows="1"
                class="form-control"
                placeholder="{{ helper.placeholder.reason_text | translate }}"
              ></textarea>
            </form>
          </li>
        </ul>
      </div>
    </div>
    <div class="modal-footer">
      <div
        class="modal-footer-wrp d-flex align-items-center justify-content-center"
      >
        <button
          class="primary-btn border-btn"
          (click)="modal.dismiss('Cross click')"
        >
          {{ helper.button.annuler | translate }}
        </button>
        <button class="primary-btn m-l-15" (click)="cancel_order()">
          {{ helper.button.confirmer | translate }}
        </button>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #EditCart let-modal>
  <div class="modal-main">
    <!-- <button type="button" class="close pull-right" aria-label="Close" (click)="modal.dismiss('Cross click')">
            <span aria-hidden="true"><svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0.641964 4.44674C0.27079 4.07556 0.0852035 3.64252 0.0852036 3.14762C0.0852039 2.65272 0.270791 2.21969 0.641965 1.84851C1.01314 1.47734 1.43844 1.29948 1.91788 1.31495C2.39731 1.33042 2.82261 1.52374 3.19379 1.89491L12.6355 11.3367C13.0067 11.7078 13.1923 12.1409 13.1923 12.6358C13.2078 13.1152 13.0299 13.5405 12.6587 13.9117C12.2876 14.2829 11.8545 14.4684 11.3596 14.4684C10.8802 14.453 10.4549 14.2597 10.0837 13.8885L0.641964 4.44674ZM0.804354 13.6565C0.371317 13.2235 0.147065 12.7208 0.1316 12.1486C0.1316 11.5918 0.348119 11.0969 0.781156 10.6639L9.82853 1.61653C10.2616 1.18349 10.7642 0.974707 11.3364 0.990173C11.9087 1.00564 12.4113 1.22989 12.8443 1.66293C13.2928 2.11143 13.5093 2.60633 13.4939 3.14763C13.4939 3.70439 13.2774 4.19929 12.8443 4.63232L3.79695 13.6797C3.36391 14.1127 2.86901 14.3293 2.31225 14.3293C1.75549 14.3293 1.25286 14.105 0.804354 13.6565Z"/>
            </svg></span>
        </button> -->
    <button
      type="button"
      class="close with-name pull-right d-flex align-items-center"
      aria-label="Close"
      (click)="modal.dismiss('Cross click')"
    >
      <span aria-hidden="true">
        <label>{{ helper.button.fermer | translate }}</label>
        <svg
          width="30"
          height="30"
          viewBox="0 0 30 30"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M15 3C12.6266 3 10.3066 3.70379 8.33316 5.02236C6.35977 6.34094 4.8217 8.21508 3.91345 10.4078C3.0052 12.6005 2.76756 15.0133 3.23058 17.3411C3.6936 19.6689 4.83649 21.807 6.51472 23.4853C8.19295 25.1635 10.3311 26.3064 12.6589 26.7694C14.9867 27.2324 17.3995 26.9948 19.5922 26.0865C21.7849 25.1783 23.6591 23.6402 24.9776 21.6668C26.2962 19.6934 27 17.3734 27 15C27 13.4241 26.6896 11.8637 26.0866 10.4078C25.4835 8.95189 24.5996 7.62902 23.4853 6.51472C22.371 5.40041 21.0481 4.5165 19.5922 3.91345C18.1363 3.31039 16.5759 3 15 3ZM18.252 16.548C18.3645 16.6596 18.4538 16.7923 18.5147 16.9385C18.5756 17.0847 18.607 17.2416 18.607 17.4C18.607 17.5584 18.5756 17.7153 18.5147 17.8615C18.4538 18.0077 18.3645 18.1404 18.252 18.252C18.1404 18.3645 18.0077 18.4537 17.8615 18.5147C17.7153 18.5756 17.5584 18.607 17.4 18.607C17.2416 18.607 17.0847 18.5756 16.9385 18.5147C16.7923 18.4537 16.6596 18.3645 16.548 18.252L15 16.692L13.452 18.252C13.3404 18.3645 13.2077 18.4537 13.0615 18.5147C12.9153 18.5756 12.7584 18.607 12.6 18.607C12.4416 18.607 12.2847 18.5756 12.1385 18.5147C11.9923 18.4537 11.8596 18.3645 11.748 18.252C11.6355 18.1404 11.5463 18.0077 11.4853 17.8615C11.4244 17.7153 11.393 17.5584 11.393 17.4C11.393 17.2416 11.4244 17.0847 11.4853 16.9385C11.5463 16.7923 11.6355 16.6596 11.748 16.548L13.308 15L11.748 13.452C11.522 13.226 11.3951 12.9196 11.3951 12.6C11.3951 12.2804 11.522 11.974 11.748 11.748C11.974 11.522 12.2804 11.3951 12.6 11.3951C12.9196 11.3951 13.226 11.522 13.452 11.748L15 13.308L16.548 11.748C16.774 11.522 17.0804 11.3951 17.4 11.3951C17.7196 11.3951 18.026 11.522 18.252 11.748C18.478 11.974 18.6049 12.2804 18.6049 12.6C18.6049 12.9196 18.478 13.226 18.252 13.452L16.692 15L18.252 16.548Z"
          />
        </svg>
      </span>
    </button>
    <!-- <div class="modal-header justify-content-center no-header">

        </div> -->
    <div class="modal-body">
      <div class="modal-body-wrp">
        <div class="cart-dropdown v-scroll-hide">
          <div class="cart-dropdown-wrp">
            <div class="cart-product-list">
              <ng-container
                *ngFor="
                  let cart_product of order_detail.cart_detail.order_details;
                  let product_index = index
                "
              >
                <div
                  class="c-p-list-box d-flex align-items-start"
                  *ngFor="
                    let cart_item of cart_product.items;
                    let item_index = index
                  "
                >
                  <div>
                    <div class="c-product-title d-flex align-items-center">
                      <h3>{{ cart_item.item_name }}</h3>
                    </div>
                    <div
                      class="c-pro-dec"
                      id="{{ cart_item.item_id + item_index }}"
                      [class.c-pro-dec-all]="cart_item.is_display_all"
                    >
                      <p>
                        <span *ngIf="cart_item.is_buy_one_get_one">
                          promotion 1+1 gratuit
                          <span *ngIf="cart_item.specifications.length > 0"
                            >,</span
                          >
                        </span>
                      </p>
                      <ng-container
                        *ngFor="
                          let specification of cart_item.specifications;
                          let specification_last = last
                        "
                      >
                        <ng-container>
                          <p
                            *ngFor="
                              let sp of specification.list;
                              let sp_last = last
                            "
                          >
                            <span>
                              {{ sp.name }}
                              <span>,</span>
                            </span>
                          </p>
                        </ng-container>
                      </ng-container>
                      <!-- <ng-container *ngFor="let formule of cart_item.formule_list; let specification_last=last;">
                                            <p>
                                                <b>
                                                formule: {{formule.name}}
                                                    <span>,</span>
                                                </b>
                                            </p>
                                            <ng-container *ngFor="let specification of cart_item.specifications; let specification_last=last;">
                                                <ng-container *ngIf="specification.formule_id==formule.formule_id">
                                                    <p *ngFor="let sp of specification.list;let sp_last=last;">
                                                        <span>
                                                        {{sp.name}}
                                                            <span>,</span>
                                                        </span>
                                                    </p>
                                                </ng-container>
                                            </ng-container>
                                        </ng-container> -->
                      <p *ngIf="cart_item.note_for_item">
                        <span>{{ cart_item.note_for_item }}</span>
                      </p>
                    </div>
                    <a
                      class="link-btn"
                      (click)="cart_item.is_display_all = true"
                      *ngIf="
                        !cart_item.is_display_all &&
                        check_button(cart_item.item_id + item_index)
                      "
                      >{{ helper.button.voir_plus | translate }}</a
                    >
                    <a
                      class="link-btn"
                      (click)="cart_item.is_display_all = false"
                      *ngIf="cart_item.is_display_all"
                    >
                      {{ helper.button.voir_minus | translate }}</a
                    >
                  </div>

                  <div class="c-pro-tag d-flex align-items-start ml-auto">
                    <div class="c-product-price ml-auto">
                      <span
                        >{{
                          order_detail.order_payment_detail.order_currency_code
                        }}
                        {{
                          (
                            cart_item.total_item_and_specification_price -
                            (cart_item.offer_price ? cart_item.offer_price : 0)
                          ).toFixed(2)
                        }}</span
                      >
                    </div>
                  </div>
                </div>
              </ng-container>
            </div>
            <div class="summary-content-list">
              <div class="s-total d-flex align-items-center">
                <h4>{{ helper.text.sous_total | translate }}</h4>
                <span
                  class="ml-auto"
                  [class.strike-price]="
                    order_detail.order_payment_detail.cart_offer_price ||
                    (!order_detail.order_payment_detail
                      .is_promo_for_delivery_service &&
                      order_detail.order_payment_detail.promo_payment)
                  "
                  >{{ order_detail.order_payment_detail.order_currency_code }}
                  {{
                    (
                      order_detail.order_payment_detail.total_cart_price +
                      order_detail.order_payment_detail.cart_offer_price
                    ).toFixed(2)
                  }}</span
                >
              </div>
              <div
                class="s-total code-promo d-flex align-items-center"
                *ngIf="order_detail.order_payment_detail.cart_offer_price"
              >
                <h4>
                  {{ order_detail.order_payment_detail.cart_offer_message }}
                </h4>
                <span
                  class="ml-auto"
                  [class.strike-price]="
                    !order_detail.order_payment_detail
                      .is_promo_for_delivery_service &&
                    order_detail.order_payment_detail.promo_payment
                  "
                  >{{ order_detail.order_payment_detail.order_currency_code }}
                  {{
                    order_detail.order_payment_detail.total_cart_price.toFixed(
                      2
                    )
                  }}</span
                >
              </div>
              <div
                class="s-total code-promo d-flex align-items-center"
                *ngIf="
                  !order_detail.order_payment_detail
                    .is_promo_for_delivery_service &&
                  order_detail.order_payment_detail.promo_payment
                "
              >
                <h4>{{ order_detail.order_payment_detail.promo_name }}</h4>
                <span class="ml-auto"
                  >{{ order_detail.order_payment_detail.order_currency_code }}
                  {{
                    (
                      (order_detail.order_payment_detail.cart_offer_price
                        ? order_detail.order_payment_detail.total_cart_price
                        : order_detail.order_payment_detail.total_cart_price) -
                      order_detail.order_payment_detail.promo_payment
                    ).toFixed(2)
                  }}</span
                >
              </div>
            </div>
            <div class="summary-content-list">
              <div class="s-total tooltip-title d-flex align-items-center">
                <div class="d-flex align-items-center">
                  <h4>{{ helper.text.frais_de_hopper | translate }}</h4>
                  <div class="tooltip-svg">
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M10 0.375C8.09636 0.375 6.23546 0.939497 4.65264 1.99711C3.06982 3.05471 1.83616 4.55793 1.10766 6.31667C0.37917 8.07541 0.188563 10.0107 0.559946 11.8777C0.931329 13.7448 1.84802 15.4598 3.1941 16.8059C4.54018 18.152 6.25519 19.0687 8.12226 19.4401C9.98933 19.8114 11.9246 19.6208 13.6833 18.8923C15.4421 18.1638 16.9453 16.9302 18.0029 15.3474C19.0605 13.7645 19.625 11.9036 19.625 10C19.625 7.44729 18.6109 4.99913 16.8059 3.1941C15.0009 1.38906 12.5527 0.375 10 0.375ZM10 4.5C10.204 4.5 10.4033 4.56048 10.5729 4.6738C10.7425 4.78711 10.8747 4.94817 10.9528 5.13661C11.0308 5.32504 11.0512 5.53239 11.0114 5.73244C10.9716 5.93248 10.8734 6.11623 10.7292 6.26045C10.585 6.40468 10.4012 6.50289 10.2012 6.54269C10.0011 6.58248 9.7938 6.56205 9.60536 6.484C9.41693 6.40595 9.25587 6.27377 9.14255 6.10418C9.02924 5.93459 8.96875 5.73521 8.96875 5.53125C8.96875 5.25775 9.0774 4.99544 9.2708 4.80205C9.4642 4.60865 9.7265 4.5 10 4.5ZM12.75 15.5859H7.25V14.0391H9.22657V10.0859H7.9375V8.53906H10.7734V14.0391H12.75V15.5859Z"
                      />
                    </svg>
                    <div class="tooltip-content">
                      <span>{{ helper.text.tooltip2 | translate }}</span>
                    </div>
                  </div>
                </div>

                <span
                  class="ml-auto strike-price"
                  [class.strike-price]="
                    order_detail.order_payment_detail.delivery_offer_price ||
                    (order_detail.order_payment_detail
                      .is_promo_for_delivery_service &&
                      order_detail.order_payment_detail.promo_payment)
                  "
                  >{{ order_detail.order_payment_detail.order_currency_code }}
                  {{
                    order_detail.order_payment_detail.total_service_price.toFixed(
                      2
                    )
                  }}</span
                >
              </div>
              <div
                class="s-total code-promo d-flex align-items-center"
                *ngIf="order_detail.order_payment_detail.delivery_offer_price"
              >
                <h4>
                  {{ order_detail.order_payment_detail.delivery_offer_message }}
                </h4>
                <span
                  class="ml-auto"
                  [class.strike-price]="
                    order_detail.order_payment_detail
                      .is_promo_for_delivery_service &&
                    order_detail.order_payment_detail.promo_payment
                  "
                  >{{ order_detail.order_payment_detail.order_currency_code }}
                  {{
                    (
                      order_detail.order_payment_detail.total_service_price -
                      order_detail.order_payment_detail.delivery_offer_price
                    ).toFixed(2)
                  }}</span
                >
              </div>
              <div
                class="s-total code-promo d-flex align-items-center"
                *ngIf="
                  order_detail.order_payment_detail
                    .is_promo_for_delivery_service &&
                  order_detail.order_payment_detail.promo_payment
                "
              >
                <h4>
                  {{ order_detail.order_payment_detail.delivery_offer_message }}
                </h4>
                <span class="ml-auto"
                  >{{ order_detail.order_payment_detail.order_currency_code }}
                  {{
                    (
                      order_detail.order_payment_detail.total_service_price -
                      order_detail.order_payment_detail.delivery_offer_price -
                      order_detail.order_payment_detail.promo_payment
                    ).toFixed(2)
                  }}</span
                >
              </div>
              <!-- <div class="s-total code-promo d-flex align-items-center">
                            <h4>test</h4>
                            <span class="ml-auto">CHF 500</span>
                        </div>
                        <div class="s-total code-promo d-flex align-items-center">
                            <h4>test2</h4>
                            <span class="ml-auto">CHF 600</span>
                        </div> -->
              <div class="s-total tooltip-title d-flex align-items-center">
                <div class="d-flex align-items-center">
                  <h4>{{ helper.text.frais_de_service | translate }}</h4>
                  <div class="tooltip-svg">
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M10 0.375C8.09636 0.375 6.23546 0.939497 4.65264 1.99711C3.06982 3.05471 1.83616 4.55793 1.10766 6.31667C0.37917 8.07541 0.188563 10.0107 0.559946 11.8777C0.931329 13.7448 1.84802 15.4598 3.1941 16.8059C4.54018 18.152 6.25519 19.0687 8.12226 19.4401C9.98933 19.8114 11.9246 19.6208 13.6833 18.8923C15.4421 18.1638 16.9453 16.9302 18.0029 15.3474C19.0605 13.7645 19.625 11.9036 19.625 10C19.625 7.44729 18.6109 4.99913 16.8059 3.1941C15.0009 1.38906 12.5527 0.375 10 0.375ZM10 4.5C10.204 4.5 10.4033 4.56048 10.5729 4.6738C10.7425 4.78711 10.8747 4.94817 10.9528 5.13661C11.0308 5.32504 11.0512 5.53239 11.0114 5.73244C10.9716 5.93248 10.8734 6.11623 10.7292 6.26045C10.585 6.40468 10.4012 6.50289 10.2012 6.54269C10.0011 6.58248 9.7938 6.56205 9.60536 6.484C9.41693 6.40595 9.25587 6.27377 9.14255 6.10418C9.02924 5.93459 8.96875 5.73521 8.96875 5.53125C8.96875 5.25775 9.0774 4.99544 9.2708 4.80205C9.4642 4.60865 9.7265 4.5 10 4.5ZM12.75 15.5859H7.25V14.0391H9.22657V10.0859H7.9375V8.53906H10.7734V14.0391H12.75V15.5859Z"
                      />
                    </svg>
                    <div class="tooltip-content">
                      <span>{{ helper.text.tooltip1 | translate }}</span>
                    </div>
                  </div>
                </div>

                <span class="ml-auto"
                  >{{ order_detail.order_payment_detail.order_currency_code }}
                  {{
                    order_detail.order_payment_detail.service_fee
                      ? order_detail.order_payment_detail.service_fee.toFixed(2)
                      : 0.0
                  }}</span
                >
              </div>
            </div>
          </div>
        </div>
        <div class="menu-cart-btn">
          <button class="primary-btn btn-desktop">
            <label>
              {{ helper.button.panier | translate }}
              <svg
                width="16"
                height="14"
                viewBox="0 0 16 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_1842_9206)">
                  <path
                    d="M14.4407 8.23916L15.7333 2.55168C15.8267 2.14103 15.5145 1.74999 15.0934 1.74999H4.35333L4.1027 0.524725C4.04024 0.219323 3.77151 0 3.45976 0H0.656247C0.293807 0 0 0.293807 0 0.656247V1.09375C0 1.45619 0.293807 1.74999 0.656247 1.74999H2.5671L4.48794 11.1408C4.0284 11.405 3.71874 11.9006 3.71874 12.4687C3.71874 13.3144 4.4043 13.9999 5.24998 13.9999C6.09566 13.9999 6.78122 13.3144 6.78122 12.4687C6.78122 12.0401 6.60494 11.6529 6.32119 11.375H12.0537C11.77 11.6529 11.5937 12.0401 11.5937 12.4687C11.5937 13.3144 12.2793 13.9999 13.125 13.9999C13.9706 13.9999 14.6562 13.3144 14.6562 12.4687C14.6562 11.8624 14.3038 11.3385 13.7927 11.0904L13.9436 10.4267C14.0369 10.016 13.7248 9.62496 13.3036 9.62496H5.96411L5.78515 8.74997H13.8008C14.1072 8.74997 14.3728 8.53794 14.4407 8.23916Z"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_1842_9206">
                    <rect width="15.7499" height="13.9999" />
                  </clipPath>
                </defs>
              </svg>
              <span class="count-pill">{{
                helper.common_data._user_cart.cart_data.total_item
              }}</span>
            </label>
            <span
              >{{ order_detail.order_payment_detail.order_currency_code }}
              {{
                helper.common_data._user_cart.cart_data.total_cart_amount.toFixed(
                  2
                )
              }}</span
            >
          </button>
          <button
            class="primary-btn btn-mob"
            (click)="modal.dismiss('Cross click')"
          >
            <label class="d-flex align-items-center">
              {{ helper.label.total | translate }}
              <span class="ml-auto"
                >{{ order_detail.order_payment_detail.order_currency_code }}
                {{ order_detail.order_payment_detail.total.toFixed(2) }}</span
              >
            </label>
            <!-- <svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#clip0_1842_9206)">
                        <path d="M14.4407 8.23916L15.7333 2.55168C15.8267 2.14103 15.5145 1.74999 15.0934 1.74999H4.35333L4.1027 0.524725C4.04024 0.219323 3.77151 0 3.45976 0H0.656247C0.293807 0 0 0.293807 0 0.656247V1.09375C0 1.45619 0.293807 1.74999 0.656247 1.74999H2.5671L4.48794 11.1408C4.0284 11.405 3.71874 11.9006 3.71874 12.4687C3.71874 13.3144 4.4043 13.9999 5.24998 13.9999C6.09566 13.9999 6.78122 13.3144 6.78122 12.4687C6.78122 12.0401 6.60494 11.6529 6.32119 11.375H12.0537C11.77 11.6529 11.5937 12.0401 11.5937 12.4687C11.5937 13.3144 12.2793 13.9999 13.125 13.9999C13.9706 13.9999 14.6562 13.3144 14.6562 12.4687C14.6562 11.8624 14.3038 11.3385 13.7927 11.0904L13.9436 10.4267C14.0369 10.016 13.7248 9.62496 13.3036 9.62496H5.96411L5.78515 8.74997H13.8008C14.1072 8.74997 14.3728 8.53794 14.4407 8.23916Z"/>
                        </g>
                        <defs>
                        <clipPath id="clip0_1842_9206">
                        <rect width="15.7499" height="13.9999"/>
                        </clipPath>
                        </defs>
                    </svg> -->
          </button>
          <!-- <button class="primary-btn btn-mob">
                    <label class="d-flex align-items-center">
                        {{helper.button.cart_d_btn | translate}} <span class="ml-auto">{{delivery_currency}} {{helper.common_data._user_cart.cart_data.total_cart_amount.toFixed(2)}}</span>
                    </label>
                </button> -->
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <div
        class="modal-footer-wrp d-flex align-items-center justify-content-center"
      >
        <div class="c-drop-footer">
          <div class="summary-total">
            <div class="summary-total-wrp d-flex align-items-center">
              <label>{{ helper.label.total | translate }}</label>
              <span class="ml-auto"
                >{{ order_detail.order_payment_detail.order_currency_code }}
                {{ order_detail.order_payment_detail.total.toFixed(2) }}</span
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>
